import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Outlet, useLocation } from "react-router-dom";
import { HeadingContext } from "../../../context/HeadingContext";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import { useTheme } from "@emotion/react";
import ErrorBoundary from "../../error/ErrorBoundary";
import { NotificationContext } from "../../../context/NotificationContext";
import { IconButton, useMediaQuery } from "@mui/material";
import { ArrowBack, Menu } from "@mui/icons-material";
import MenuDrawer from "./MenuDrawer";

const navItems = [{ title: "Schedule", path: "/shop-schedule" }];

function TopNav(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { unreadCount } = React.useContext(NotificationContext);
  const { window } = props;
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const { headingText, captionText } = React.useContext(HeadingContext);
  const handleDrawerToggle = () => {
    setDrawerOpen((prevState) => !prevState);
  };

  return (
    <>
      <MenuDrawer open={drawerOpen} toggleDrawer={handleDrawerToggle} />
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          component="nav"
          sx={{
            background: theme.palette.appBar
              ? theme.palette.appBar.background
              : "inherit",
            color: theme.palette.appBar
              ? theme.palette.appBar.contrastText
              : "inherit",
          }}
        >
          <Toolbar>
            <Box sx={{ width: "40px" }}>
              <IconButton
                onClick={() => {
                  navigate(-1);
                }}
              >
                <ArrowBack sx={{ color: "white" }} />
              </IconButton>
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                // display: { xs: "none", sm: "block" }
              }}
            >
              {/* <img
                src="/industry-metal-co-long-logo-light-outlined-icon.png"
                // height={50}
                height={40}
                onClick={() => navigate("/")}
              /> */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  // justifyContent: "center",
                  // alignItems: "center",
                }}
              >
                {headingText && (
                  <Typography
                    color
                    variant="h5"
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: "1",
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    {headingText}
                  </Typography>
                )}
                {captionText && (
                  <Typography
                    color
                    variant="subtitle2"
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: "1",
                      WebkitBoxOrient: "vertical",
                    }}
                  >
                    {captionText}
                  </Typography>
                )}
              </Box>
            </Box>
            <Box sx={{ flex: 1 }}></Box>
            <IconButton onClick={handleDrawerToggle}>
              <Menu sx={{ color: "white" }} />
            </IconButton>
          </Toolbar>
        </AppBar>

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          {/* <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              marginBottom: "1rem",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {headingText && (
                <Typography color variant="h5">
                  {headingText}
                </Typography>
              )}
              {captionText && (
                <Typography color variant="subtitle2">
                  {captionText}
                </Typography>
              )}
            </Box>
          </Box> */}
          <Container
            maxWidth={false}
            sx={{
              pt: isSmallScreen ? 8 : 12,
              mb: 4,
              paddingBottom: "80px",
              pl: 0,
              pr: 0,
            }}
          >
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </Container>
        </Box>
      </Box>
    </>
  );
}

export default TopNav;
